export default "__VITE_ASSET__CVUPiwcs__"